import React, { useState } from 'react';
import './Products.css';
import './AllSellStyles.css';
import './CommonStyles.css';
import { exportToCSV, exportToExcel, exportToPDF, printPage } from './exportUtils';

const ProductPurchaseReport = () => {
    const [entriesPerPage, setEntriesPerPage] = useState(25);
    const [searchTerm, setSearchTerm] = useState('');
    const [showExportDropdown, setShowExportDropdown] = useState(false);

    // Mock data matching the screenshot
    const mockData = [
        {
            product: 'ARIZONA HARD WATERMELON 22OZ',
            sku: '613008769918',
            supplier: 'Mr Jan-2026',
            refNo: '56521215',
            date: '01/09/2026',
            qty: '200.00 Single',
            totalUnitAdjusted: '0.00 Single',
            unitPurchasePrice: '$ 7.64',
            subtotal: '$ 1,528.00'
        },
        {
            product: 'LONE RIVER RANCH WATER 12PK',
            sku: '860003623497',
            supplier: 'testing Pvt Ltd, Mrs mahiboob reur',
            refNo: '4544',
            date: '01/11/2026',
            qty: '0.00 Single',
            totalUnitAdjusted: '0.00 Single',
            unitPurchasePrice: '$ 17.24',
            subtotal: '$ 0.00'
        },
        {
            product: 'BUD LIGHT PLATINUM 12PK CAN 12 OZ',
            sku: '018200209949',
            supplier: 'mr myb',
            refNo: '44851',
            date: '01/11/2026',
            qty: '2.00 Single',
            totalUnitAdjusted: '0.00 Single',
            unitPurchasePrice: '$ 20.51',
            subtotal: '$ 41.02'
        },
        {
            product: 'SWEET WATER HAZY IPA 12OZ 6PK',
            sku: '631234451124',
            supplier: 'testing Pvt Ltd, Mrs mahiboob reur',
            refNo: '354412',
            date: '01/11/2026',
            qty: '1.00 Single',
            totalUnitAdjusted: '0.00 Single',
            unitPurchasePrice: '$ 8.14',
            subtotal: '$ 8.14'
        },
        {
            product: 'LONE RIVER RANCH WATER 12PK',
            sku: '860003623497',
            supplier: 'testing Pvt Ltd, Mrs mahiboob reur',
            refNo: '184521',
            date: '01/11/2026',
            qty: '2.00 Single',
            totalUnitAdjusted: '0.00 Single',
            unitPurchasePrice: '$ 17.24',
            subtotal: '$ 34.48'
        }
    ];

    const handleExport = (format) => {
        const headers = ['Product', 'SKU', 'Supplier', 'Reference No', 'Date', 'Quantity', 'Total Unit Adjusted', 'Unit Purchase Price', 'Subtotal'];
        const rows = mockData.map(r => [
            r.product || '',
            r.sku || '',
            r.supplier || '',
            r.refNo || '',
            r.date || '',
            r.qty || '0.00 Single',
            r.totalUnitAdjusted || '0.00 Single',
            r.unitPurchasePrice || '$ 0.00',
            r.subtotal || '$ 0.00'
        ]);

        const title = 'Product Purchase Report';
        const filename = 'product_purchase_report';

        if (format === 'CSV') exportToCSV(headers, rows, filename);
        else if (format === 'Excel') exportToExcel(headers, rows, filename);
        else if (format === 'PDF') exportToPDF(title, headers, rows, filename);
        else if (format === 'Print') printPage();

        setShowExportDropdown(false);
    };

    return (
        <div style={{ paddingTop: '0.5rem' }}>

            {/* ── Product Purchase Table Container ── */}
            <div style={{
                background: '#fff',
                border: '1px solid #e2e8f0',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
            }}>

                {/* Table controls */}
                <div className="table-controls" style={{ borderBottom: '1px solid #e2e8f0', padding: '1rem 1.25rem' }}>
                    <div className="table-controls-left">
                        <div className="entries-select">
                            <span>Show</span>
                            <select value={entriesPerPage} onChange={e => setEntriesPerPage(Number(e.target.value))}>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                            <span>entries</span>
                        </div>
                    </div>

                    <div className="table-controls-right">
                        {/* Single Export dropdown */}
                        <div className="export-dropdown-container" style={{ position: 'relative' }}>
                            <button
                                className="export-btn"
                                onClick={() => setShowExportDropdown(!showExportDropdown)}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: '0.4rem',
                                    padding: '0.4rem 0.8rem', border: '1px solid #e2e8f0',
                                    borderRadius: '6px', background: '#fff', cursor: 'pointer',
                                    fontSize: '0.85rem', color: '#334155'
                                }}
                            >
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    <polyline points="7 10 12 15 17 10" />
                                    <line x1="12" y1="15" x2="12" y2="3" />
                                </svg>
                                Export ▾
                            </button>
                            {showExportDropdown && (
                                <div className="export-dropdown-menu" style={{
                                    position: 'absolute', top: '100%', right: 0, marginTop: '0.25rem',
                                    background: '#fff', border: '1px solid #e2e8f0', borderRadius: '6px',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', zIndex: 10, minWidth: '160px'
                                }}>
                                    {[
                                        { icon: 'fa-file-excel-o', label: 'Export CSV', action: () => handleExport('CSV') },
                                        { icon: 'fa-file-excel-o', label: 'Export Excel', action: () => handleExport('Excel') },
                                        { icon: 'fa-print', label: 'Print', action: () => handleExport('Print') },
                                        { icon: 'fa-table', label: 'Column visibility' },
                                        { icon: 'fa-file-pdf-o', label: 'Export PDF', action: () => handleExport('PDF') },
                                    ].map((item, i) => (
                                        <button
                                            key={i}
                                            onClick={() => { if (item.action) item.action(); else setShowExportDropdown(false); }}
                                            style={{
                                                display: 'flex', alignItems: 'center', gap: '0.5rem',
                                                width: '100%', padding: '0.5rem 1rem', border: 'none',
                                                background: 'none', textAlign: 'left', cursor: 'pointer',
                                                fontSize: '0.8125rem', color: '#475569'
                                            }}
                                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f1f5f9'}
                                            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                        >
                                            <i className={`fa ${item.icon}`} style={{ width: '14px', textAlign: 'center' }} />
                                            {item.label}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Search */}
                        <input
                            type="text"
                            placeholder="Search ..."
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                            style={{
                                padding: '0.4rem 0.75rem',
                                border: '1px solid #e2e8f0',
                                borderRadius: '6px',
                                fontSize: '0.8125rem',
                                outline: 'none',
                                width: '180px',
                            }}
                        />
                    </div>
                </div>

                {/* Table */}
                <div style={{ overflowX: 'auto' }}>
                    <table className="products-table" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                        <thead>
                            <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600' }}>Product <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600' }}>SKU <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600' }}>Supplier <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600' }}>Reference<br />No <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600' }}>Date <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600' }}>Quantity <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600' }}>Total Unit<br />Adjusted <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600' }}>Unit Purchase<br />Price <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600' }}>Subtotal <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {mockData.map((row, idx) => (
                                <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.product}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.sku}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.supplier}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#3b82f6', cursor: 'pointer' }}>{row.refNo}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.date}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.qty}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.totalUnitAdjusted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.unitPurchasePrice}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.subtotal}</td>
                                </tr>
                            ))}
                            {/* Footer Total Row */}
                            <tr style={{ background: '#e2e8f0', fontWeight: '700' }}>
                                <td colSpan="5" style={{ padding: '0.75rem 1rem', textAlign: 'center', fontSize: '0.8125rem', color: '#1e293b' }}>Total:</td>
                                <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b' }}>205.00</td>
                                <td style={{ padding: '0.75rem 1rem' }}></td>
                                <td style={{ padding: '0.75rem 1rem' }}></td>
                                <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b' }}>$ 1,611.64</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination" style={{ padding: '0.85rem 1.25rem', borderTop: '1px solid #e2e8f0' }}>
                    <div className="pagination-info" style={{ fontSize: '0.8125rem' }}>
                        Showing 1 to 5 of 5 entries
                    </div>
                    <div className="pagination-controls">
                        <button className="page-btn disabled">Previous</button>
                        <button className="page-btn active">1</button>
                        <button className="page-btn disabled">Next</button>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default ProductPurchaseReport;
